// extracted by mini-css-extract-plugin
export default {"modal":"AddNew_modal__fVNz5","modal__shade":"AddNew_modal__shade__MTqdU","modal__form":"AddNew_modal__form__cEKpr"};